import { render } from "./DuplicateTemplateModal.vue?vue&type=template&id=db16bf9c&scoped=true"
import script from "./DuplicateTemplateModal.vue?vue&type=script&lang=js"
export * from "./DuplicateTemplateModal.vue?vue&type=script&lang=js"

import "./DuplicateTemplateModal.vue?vue&type=style&index=0&id=db16bf9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db16bf9c"]])

export default __exports__